function tokenFactory() {
  function setAccessToken(accessToken) {
    window.sessionStorage.setItem('accessToken', JSON.stringify(accessToken));
  }

  function setIdToken(idToken) {
    window.sessionStorage.setItem('idToken', JSON.stringify(idToken));
  }

  function setRefreshToken(refreshToken) {
    window.sessionStorage.setItem('refreshToken', JSON.stringify(refreshToken));
  }

  function getAccessToken() {
    return JSON.parse(window.sessionStorage.getItem('accessToken'));
  }

  function getIdToken() {
    return JSON.parse(window.sessionStorage.getItem('idToken'));
  }

  function getRefreshToken() {
    const result = JSON.parse(window.sessionStorage.getItem('refreshToken'));
    return result?.token;
  }

  function getUserName() {
    const userData = JSON.parse(window.sessionStorage.getItem('accessToken'));
    return userData?.payload?.username;
  }

  function removeAll() {
    window.sessionStorage.clear();
    window.localStorage.clear();
  }

  return {
    getAccessToken,
    getIdToken,
    getRefreshToken,
    getUserName,
    setAccessToken,
    setIdToken,
    setRefreshToken,
    removeAll,
  };
}

const token = tokenFactory();

export default token;
